import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {faCircleCheck, faCircleXmark} from "@fortawesome/pro-solid-svg-icons";

export enum FileCircleState {
  START = "start",
  ANALYSING = "analysing",
  READY = "ready",
  CHECKED = "checked",
  ERROR = "error",
}


@Component({
  selector: 'files-status-circle',
  templateUrl: './files-status-circle.component.html',
  imports: [
    FaIconComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './files-status-circle.component.scss'
})
export class FilesStatusCircleComponent implements OnInit{

  @Input() state: FileCircleState = FileCircleState.START;
  @Input() value: number = 20;

  private readonly circumference: number = 772.45;

  constructor() { }

  protected readonly faCircleXmark = faCircleXmark;

  public calculateDashOffset(): number {
    return this.circumference - (this.value / 100 * this.circumference);
  }

  protected readonly CircleState = FileCircleState;
  protected readonly faCircleCheck = faCircleCheck;

  ngOnInit(): void {
    switch (this.state) {
      case FileCircleState.START:
        this.value = 0;
        break;
      case FileCircleState.ANALYSING:
        this.value = 20;
        break;
      case FileCircleState.READY:
        this.value = 100;
        break;
      case FileCircleState.CHECKED:
        this.value = 100;
        break;
      case FileCircleState.ERROR:
        this.value = 100;
        break;
    }
  }
}
